import "core-js/modules/es6.regexp.split";
//
//
//
//
export default {
  name: 'JCheckbox',
  props: {
    value: {
      type: String,
      required: false
    },

    /*label value*/
    options: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      checkboxArray: !this.value ? [] : this.value.split(",")
    };
  },
  watch: {
    value: function value(val) {
      if (!val) {
        this.checkboxArray = [];
      } else {
        this.checkboxArray = this.value.split(",");
      }
    }
  },
  methods: {
    onChange: function onChange(checkedValues) {
      this.$emit('change', checkedValues.join(","));
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
};